import Flux from 'flux';
import { PayloadSources } from 'search/constants';
import Honeybadger from '@honeybadger-io/js';

const Dispatcher = Object.assign(new Flux.Dispatcher(), {
  /**
   * @param {object} action The details of the action, including the action's
   * type and additional data coming from the view.
   */
  handleViewAction(action) {
    const payload = {
      source: PayloadSources.VIEW_ACTION,
      action: action
    };
    this.dispatch(payload);
  },

  /**
   * @param {object} action The details of the action, including the action's
   * type and additional data coming from the server.
   */
  handleServerAction(action) {
    const payload = {
      source: PayloadSources.SERVER_ACTION,
      action: action
    };
    this.dispatch(payload);
  }
});

// Recreate Honeybadger.wrap(Dispatcher.dispatch) functionality
// https://docs.honeybadger.io/lib/javascript/support/upgrading-to-v3/
//
// We need to always return the same function so that callbacks can
// be removed via removeEventListener. The code below is copy-pasted
// from original honeybadger-js v2.x with unnecessary conditionals removed:
// https://github.com/honeybadger-io/honeybadger-js/blob/v2.2.2/src/builder.js#L388-L429
function wrapWithHoneybadger(fn) {
  try {
    if (!fn.___hb) {
      fn.___hb = function () {
        try {
          return fn.apply(this, arguments);
        } catch (err) {
          Honeybadger.notify(err);
          throw err;
        }
      };
    }
    fn.___hb.___hb = fn.___hb;
    return fn.___hb;
  } catch (_e) {
    return fn;
  }
}
Dispatcher.dispatch = wrapWithHoneybadger(Dispatcher.dispatch);

export default Dispatcher;
